<div class="backModal enCalendar">
  <div class="close closeModal">
    <a (click)="close()" title="cerrar"
      ><span class="cross"></span
      ><span class="sr-only">{{ 'CERRAR' | translate }}</span></a
    >
  </div>
  <div class="aviso">
    <div class="tituloSearch">
      {{ 'MENSAJE_CANJEO_CADUCADO' | translateV2 }}
    </div>
    <div class="faturacion-fila">
      <div class="ticket-info">
        <div class="inputControl botones">
          <button
            type="button"
            value="cancelar"
            class="cancelar"
            (click)="close()"
          >
            {{ 'CANCELAR' | translate }}
          </button>
        </div>
      </div>
      <div class="ticket-info">
        <div class="inputControl botones">
          <button
            type="button"
            value="ACEPTAR"
            class="pagar aceptar"
            (click)="canjearVenta()"
          >
            {{ 'ACEPTAR' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
